import dayjs from 'dayjs';

export const DataColumns = [
  {
    title: "Date",
    dataIndex: "date",
    defaultSortOrder: "descend",
    sorter: (a, b) => new Date(a.date) - new Date(b.date),
    render: (date, record) => {
      if (record?.isTotal) return <strong>{date}</strong>;
      return dayjs(date).format("DD-MM-YYYY");
    },
  },
  {
    title: "API's Used",
    dataIndex: "apiUsed",
    render: (val, record) => record?.isTotal ? <strong>{val}</strong> : val,
  },
  {
    title: "Total Request",
    dataIndex: "totalRequest",
    render: (val, record) => record?.isTotal ? <strong>{val}</strong> : val,
  },
  {
    title: "Success Count",
    dataIndex: "successCount",
    render: (val, record) => record?.isTotal ? <strong>{val}</strong> : val,
  },
  {
    title: "Failure Count",
    dataIndex: "failureCount",
    render: (val, record) => record?.isTotal ? <strong>{val}</strong> : val,
  },
  {
    title: "Success Rate",
    dataIndex: "successRate",
    render: (val, record) => {
      if (record?.isTotal) return <strong>{val != null ? `${val}%` : "-"}</strong>;
      return `${val}%`;
    },
  },
  {
    title: "Credit Utilized",
    dataIndex: "creditsUtilized",
    render: (val, record) => record?.isTotal ? <strong>{val}</strong> : val,
  },
  {
    title: "Usage",
    dataIndex: "usage",
  },
];
